import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ApiServiceService } from '../_service/api-service.service';
import { data } from 'jquery';
import { IfStmt } from '@angular/compiler';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  userForm: FormGroup;
  @Output() districtadmin_constituency: EventEmitter<any> = new EventEmitter();
  failedAttempts = 1;
  numLockedOut: any;
  // btnDisable = true;
  count = 6;
  test_ph: string;
  login_type: string = '';
  //  count=2;
  spinner: boolean = true;
  first1: boolean = true;
  firstLoad: any = true;
  userdetails: any =[] 

  constructor(private fb: FormBuilder,
    private dataService: ApiServiceService,
    private router: Router, private spinnerService: NgxSpinnerService) {
   // sessionStorage.setItem('validUserToken', 'false');

    this.userForm = this.fb.group({
      whatsapp_no: ['', [Validators.required, Validators.pattern('[0-9]{10,15}')]],
      password: ['', Validators.required],
    });
    //console.log(this.userForm);
  }

  ngOnInit(): void {
    this.hidePassword = true;
    this.userdetails.push(JSON.parse(localStorage.getItem('login_user_details')));
    if (Array.isArray(this.userdetails) && this.userdetails.length > 0 && this.userdetails[0] !== null) {
      console.log(this.userdetails);
      sessionStorage.setItem('validUserToken', 'true');
      this.autologin(this.userdetails);
      localStorage.setItem('isLoginComponentVisited', 'true');
  } else {
      this.router.navigate(['/']); // Navigate to a different route
  }
  
  }
  captchaError: boolean = false;
  recaptchaToken: string | null = null;
  captchaResolved: boolean = false;

  onCaptchaResolved(response: string) {
    if (response) {
      this.recaptchaToken = response;
      this.captchaResolved = true;
      this.captchaError = false;
    } else {
      this.captchaResolved = false;
      this.captchaError = true;
    }
  }
  reload() { window.location.reload(); }

  // getlogincheck(c) {
  //   console.log(c)
  //   if (c.length >= 10) {
  //     this.showSpinner();
  //     this.get_user(c);
  //   }
  //   else{
  //     this.test_ph = "true";
  //   }
  // }

  // get_user(c) {
  //   this.dataService.logincheck(c).subscribe(data => {
  //     //  console.log(data);
  //     if (data == true) {
  //       this.spinnerService.hide();
  //       this.test_ph = "false";
  //     }
  //     else {

  //       this.get_student(c)
  //     }
  //   });

  // }
  // get_student(c) {
  //   this.dataService.studentCheck(c).subscribe(data => {

  //     if (data == true) {
  //       this.login_type = 'student';
  //       this.spinnerService.hide();

  //       this.test_ph = "false";
  //     }
  //     else {

  //       this.get_mentor(c);
  //     }

  //   });
  // }


  // get_mentor(c) {

  //   this.dataService.MentorCheck(c).subscribe(data => {

  //     if (data == true) {
  //       this.login_type = 'mentor';
  //       this.spinnerService.hide();

  //       this.test_ph = "false";
  //     }
  //     else {
  //       this.spinnerService.hide();
  //       this.test_ph = "true";
  //     }
  //   });
  // }

  getlogincheck(c: string) {
  // Only proceed if the input length is at least 10 digits
  if (c.length >= 10) {
    this.showSpinner();
    this.get_user(c);
  } else {
    this.test_ph = 'true'; // Trigger error for less than 10 digits
  }
}

get_user(c: string) {
  this.dataService.logincheck(c).subscribe((data) => {
    if (data === true) {
      this.spinnerService.hide();
      this.test_ph = 'false'; // Number found, no error
    } else {
      this.get_student(c);
    }
  });
}

get_student(c: string) {
  this.dataService.studentCheck(c).subscribe((data) => {
    if (data === true) {
      this.login_type = 'student';
      this.spinnerService.hide();
      this.test_ph = 'false'; // Number found, no error
    } else {
      this.get_mentor(c);
    }
  });
}

get_mentor(c: string) {
  this.dataService.MentorCheck(c).subscribe((data) => {
    if (data === true) {
      this.login_type = 'mentor';
      this.spinnerService.hide();
      this.test_ph = 'false'; // Number found, no error
    } else {
      this.spinnerService.hide();
      this.test_ph = 'true'; // Number not found, show error
    }
  });
}
onInputNumber(event: Event): void {
  const inputElement = event.target as HTMLInputElement;
  const value = inputElement.value;
  const allowedCharacters = /^[0-9]*$/;

  // Remove any non-numeric characters
  if (!allowedCharacters.test(value)) {
    inputElement.value = value.replace(/[^0-9]/g, '');
  }
}

  public showSpinner(): void {
    this.spinnerService.show();
  }



  isFormDisabled(): boolean {
    // Disable the button if the form is invalid or the CAPTCHA is not resolved
    return !this.userForm.valid || !this.captchaResolved;
  }



  get whatsapp_no() { return this.userForm.get('whatsapp_no'); }
  get password() { return this.userForm.get('password'); }
  attempts: any;
  postdata(userForm: any) {
    console.log(userForm);
    if (userForm.status == "VALID") {
      console.log(this.failedAttempts)
      /* Only attempt login if user has less than 5 login attempts */
     
        userForm.value['captcha'] = this.recaptchaToken;
        /* Only attempt login if user has less than 5 login attempts */
        if (this.failedAttempts < this.count) {
          this.showSpinner();
          this.dataService.userlogin(userForm.value.whatsapp_no, userForm.value.password, this.login_type, userForm.value.captcha)
          .pipe(first())
          .subscribe(
            data => {
              console.log(data);
              console.log(data[0].profile_status)
              this.autologin(data);
            }
            , (err) => {

              console.error(err);
              this.attempts = 6 - this.failedAttempts;

              Swal.fire({
                icon: 'error', // Icon for the modal (error, warning, success, info, question)
                title: '<span style="font-size: 20px">Incorrect UserID / Password</span>', // Adjust the font-size as needed
                confirmButtonColor: '#015792', // Color of the confirm button
                confirmButtonText: 'OK', // Text for the confirm button
                showCancelButton: false, // Hide the cancel button
                customClass: {
                  container: 'custom-modal-container', // Class to customize the modal container
                }
              }).then(() => {
                // When the user clicks the "OK" button in the modal
                this.spinnerService.hide(); // Hides spinner (if applicable)
                location.reload();
                 // Reloads the page
              });



            });
      }

      else {
        /*increments number of times locked out */
        this.numLockedOut++;
        this.dataService.locked(userForm.value.whatsapp_no)
          .pipe(first())
          .subscribe(
            data => {
              alert("Your account has been locked please contact admin");
            });
        this.spinnerService.hide();
        // alert('Login failed. Invalid email or password. Your account was blocked');
        // this.btnDisable = true;

      }
    }

    else {
      Swal.fire({
        icon: 'error',
        title: 'Invalid UserID/Password',
        confirmButtonColor: '#015792',
        showCancelButton: true,
        confirmButtonText: 'OK',
      }).then((result) => {
        if (result.isConfirmed) {
          // Reload the page
          location.reload();
        }
      });

    }

  }


  autologin(data):any{
    if (data[0].profile_status) {
      if (data[0].category == 'SAD') {
        const redirect = this.dataService.redirectUrl ? this.dataService.redirectUrl : 'superadmin';
        this.router.navigate([redirect]);
        this.districtadmin_constituency.emit(data[0].district);
        this.spinnerService.hide();
        // window.location.reload();
      }
   
      else if (data[0].category == 'DA') {
        const redirect = this.dataService.redirectUrl ? this.dataService.redirectUrl : 'districtadmin';
        localStorage.setItem('category', JSON.stringify(data[0].category));
        this.router.navigate([redirect]);
        this.districtadmin_constituency.emit(data[0].district);
        this.spinnerService.hide();
        // window.location.reload();
      }
     else {
        const redirect = this.dataService.redirectUrl ? this.dataService.redirectUrl : 'student';
        console.log(redirect + '/stdashboard')
        // this.router.navigate([redirect]);
        this.router.navigate([redirect + '/stdashboard']);
        this.districtadmin_constituency.emit(data[0].district);
        this.spinnerService.hide();
        // window.location.reload();
      }
    }
    else if (data[0].college_name != '' && data[0].college_name != undefined) {
      if (data[0].deleted == 0) {
        //   if(data[0].log == 1) {  
        //    Swal.fire({
        //         icon: 'error',
        //         title: 'Oops...',
        //         text: 'You are already logged in on another device',
        //         confirmButtonText: "OK",
        //         iconColor: "#015792" ,
        //         customClass: {
        //           container: 'custom-modal-container', // Class to customize the modal container
        //         }// Set the icon color here
        //     }).then(() => {
        //         this.spinnerService.hide();
        //         window.location.reload(); // Reload the page
        //     });
        // } 
        //else {
        const redirect = this.dataService.redirectUrl ? this.dataService.redirectUrl : 'student';
        console.log(redirect + '/stdashboard')
        this.router.navigate([redirect + '/stdashboard']);
        this.districtadmin_constituency.emit(data[0].district);
        this.spinnerService.hide();
        //  }
      } else {
        Swal.fire({
          title: "Your account has already been closed",
          icon: "info",
          confirmButtonText: "OK",
          iconColor: "#015792",
          customClass: {
            container: 'custom-modal-container', // Class to customize the modal container
          } // Set the icon color here
        }).then(() => {
          this.spinnerService.hide();
          window.location.reload(); // Reload the page
        });



      }
    }
    else if (data[0].education != '') {
      console.log('data: ', data[0].status);

      // if(data[0].status==="Active" ) { 
      if (data[0].deleted == 0 || data[0].log == 0) {

        //   if (data[0].log==1 ) {
        //     Swal.fire({
        //         icon: 'error',
        //         title: 'Oops...',
        //         text: 'You are already logged in on another device',
        //         confirmButtonText: "OK",
        //         iconColor: "#015792",
        //         customClass: {
        //           container: 'custom-modal-container', // Class to customize the modal container
        //         } // Set the icon color here
        //     }).then(() => {
        //         this.spinnerService.hide();
        //         window.location.reload(); // Reload the page
        //     });
        // } else {
        //       }
        const redirect = this.dataService.redirectUrl ? this.dataService.redirectUrl : 'mentors';
        console.log('redirect, ', redirect);
        this.router.navigate([redirect + '/mtdashboard']);
        this.districtadmin_constituency.emit(data[0].district);
        this.spinnerService.hide();

      }
      // else {
      //   Swal.fire({
      //     title: "Your account has already been closed",
      //     icon: "info",
      //     confirmButtonText: "OK",
      //     iconColor: "#015792",
      //     customClass: {
      //       container: 'custom-modal-container', // Class to customize the modal container
      //     } // Set the icon color here
      //   }).then(() => {
      //     this.spinnerService.hide();
      //     window.location.reload(); // Reload the page
      //   });

      // }
      // }
      //    else {
      //     Swal.fire({
      //         title: "You are contacting the super admin",
      //         icon: "info",
      //         confirmButtonText: "OK",
      //         iconColor: "#015792" ,
      //         customClass: {
      //           container: 'custom-modal-container', // Class to customize the modal container
      //         }// Set the icon color here
      //     }).then(() => {
      //         this.spinnerService.hide();
      //     });
      // }

    }

    else if (data[0].profile_status == '1') {
      alert("Your account has been locked because you have reached the maximum invalid login attempts. Please contact administrator.");
      this.spinnerService.hide();
      window.location.reload();
    }
  }
  hidePassword = true;

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }
  footerdate = new Date().getFullYear();
}
